
const ExcelIcon = () => {
    return (
        <svg
            id="Layer_1"
            x="0px"
            y="0px"
            viewBox="0 0 512 512"
        >
            <g>
                <g>
                    <path d="M439.658,91.21L351.435,2.987C349.522,1.075,346.928,0,344.223,0H79.554c-5.633,0-10.199,4.566-10.199,10.199v491.602 c0,5.633,4.566,10.199,10.199,10.199h352.892c5.632,0,10.199-4.566,10.199-10.199V98.422 C442.645,95.717,441.57,93.123,439.658,91.21z M354.422,34.823l53.401,53.4h-53.401V34.823z M422.247,491.602H89.753V20.398 h244.271v78.024c0,5.633,4.567,10.199,10.199,10.199h78.024V491.602z" />
                </g>
            </g>
            <g>
                <g>
                    <path d="M282.012,454.884H119.331c-5.633,0-10.199,4.566-10.199,10.199s4.566,10.199,10.199,10.199h162.681 c5.632,0,10.199-4.566,10.199-10.199S287.644,454.884,282.012,454.884z" />
                </g>
            </g>
            <g>
                <g>
                    <path d="M334.026,454.884h-11.067c-5.632,0-10.199,4.566-10.199,10.199s4.567,10.199,10.199,10.199h11.067 c5.632,0,10.199-4.566,10.199-10.199S339.658,454.884,334.026,454.884z" />
                </g>
            </g>
            <g>
                <g>
                    <path d="M311.6,263.139l75.737-93.534c2.473-3.056,2.972-7.261,1.278-10.809c-1.692-3.549-5.274-5.808-9.205-5.808h-84.952 c-3.078,0-5.99,1.389-7.926,3.781L256,194.475l-30.532-37.706c-1.936-2.392-4.849-3.781-7.926-3.781H132.59 c-3.931,0-7.513,2.259-9.206,5.808c-1.693,3.548-1.194,7.754,1.279,10.809l75.737,93.534l-75.737,93.534 c-2.474,3.056-2.972,7.261-1.279,10.809c1.693,3.548,5.274,5.808,9.206,5.808h84.952c3.077,0,5.99-1.389,7.926-3.781L256,331.804 l30.531,37.706c1.936,2.392,4.849,3.781,7.926,3.781h84.953c3.931,0,7.513-2.259,9.205-5.808 c1.693-3.548,1.195-7.754-1.279-10.809L311.6,263.139z M299.323,173.386h58.706l-59.553,73.545l-29.352-36.25L299.323,173.386z  M212.677,352.892h-58.706l59.552-73.545l29.352,36.25L212.677,352.892z M299.323,352.892L153.971,173.386h58.706l145.351,179.506 H299.323z" />
                </g>
            </g>
        </svg>
    )
}

export default ExcelIcon
